import { useState } from 'react'
import Container from '../(public-pages)/landing/components/LandingContainer'
import { motion, AnimatePresence } from 'framer-motion'
import Link from 'next/link'

const stackList = [
    {
        id: 'men.webp',
        title: 'Противовирусные СИЗ',
        description:
            'Комбинезоны, куртки, брюки — всё, чтобы вы чувствовали себя уверенно на любой работе. Износостойкие материалы, современные фасоны и защита от любых условий.',
        href: '/catalog/muzhskaya-specodezhda_kurtki'
    },
    {
        id: 'obuv.webp',
        title: 'Спецобувь',
        description:
            'Защитная обувь для любых условий: зима, лето, влажные и агрессивные среды. Антискользящие подошвы, усиленный носок и комфорт на весь рабочий день.',
        href: '/catalog/obuv'
    },
    {
        id: 'spec.webp',
        title: 'Спецодежда',
        description:
            'Рабочая одежда для строительства, производства и сервисных работ. Износостойкие ткани, удобный крой и аккуратный внешний вид.',
        href: '/catalog/signalnaya-specodezhda'
    },
    {
        id: 'perchatki.png',
        title: 'Защита рук',
        description:
            'Перчатки и рукавицы для точных, тяжёлых и грязных работ. Защита от порезов, химии и холода с сохранением подвижности рук.',
             href: '/catalog/perchatki'
    },
    {
        id: 'svarochnaya.webp',
        title: 'Для сварщиков',
        description:
            'Огнестойкая спецодежда и защита для сварочных работ. Максимальная безопасность при высоких температурах и искрах.',
            href: '/catalog/svarochnaya-specodezhda'
    },
    {
        id: 'acsessuar.png',
        title: 'Аксессуары',
        description:
            'Рабочие головные уборы, ремни и навесные карманы. Дополняют экипировку и повышают удобство в работе.',
            href: '/catalog/aksessuary'
    },
]

// const stackList = [
//     {
//         id: 'men.webp',
//         title: 'Противовирусные СИЗ',
//         description:
//             'Комбинезоны, куртки, брюки — всё, чтобы вы чувствовали себя уверенно на любой работе. Износостойкие материалы, современные фасоны и защита от любых условий.',
//     },
//     {
//         id: 'obuv.webp',
//         title: 'Спецобувь',
//         description: 'Зимняя обувь Летняя обувь Спецобувь резиновая и ПВХ',
//     },
//     {
//         id: 'spec.webp',
//         title: 'Спецодежда',
//         description:
//             `<ul>
//             <li>Одноразовая спецодежда</li>
//             <li>Влагозащитная спецодежда</li>
//             <li>Нательное белье</li>
//             <li>Футболки</li>
//              <li>Трикотаж</li>`,
//     },
//     {
//         id: 'perchatki.png',
//         title: 'Средства защиты рук',
//         description:
//             'Рабочие перчатки Рабочие рукавицы Защитные крема ЭленАнтисептики',
//     },
//     {
//         id: 'svarochnaya.webp',
//         title: 'Спецодежда для сварщиков',
//         description:
//             ' Защита головы и лица Защита органов дыхания Защита органов зрения',
//     },
//     {
//         id: 'acsessuar.png',
//         title: 'Аксессуары',
//         description: 'Бесболки и панами Шапки Ремни и навесные карманаы все ля вашей стильной работы',
//     },
// ]

const TechStack = () => {
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null)

    return (
        <div id="demos" className="relative z-20 py-16 px-6 lg:px-16 ">
            <motion.div
                className="text-center mb-16"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, type: 'spring', bounce: 0.1 }}
                viewport={{ once: true }}
            >
                <motion.h2 className="text-xl lg:text-4xl ">
                    {' '}
                    Мы предлагаем
                    <span className="block text-sm font-normal mt-4">
                         спецодежду и средства индивидуальной защиты
                    </span>
                </motion.h2>
                {/* <motion.span className="mx-auto max-w-[600px]">
                    Средства защиты по доступным ценам
                </motion.span> */}
            </motion.div>
            <Container>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                    {stackList.map((stack, index) => (
                        <motion.div
                            key={stack.id}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{
                                duration: 0.3,
                                type: 'spring',
                                bounce: 0.1,
                                delay: index * 0.1,
                            }}
                            viewport={{ once: true }}
                            className="relative p-4"
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <AnimatePresence>
                                {hoveredIndex === index && (
                                    <motion.span
                                        className="absolute inset-0 h-full w-full bg-black/5 dark:bg-white/5 block rounded-3xl pointer-events-none z-9"
                                        layoutId="hoverBackground"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{
                                            duration: 0.25,
                                            ease: 'easeOut',
                                        }}
                                    />
                                )}
                            </AnimatePresence>
                                <Link href={stack.href}>
                                         <div className="p-4 rounded-2xl z-10 relative bg-white dark:bg-gray-950 border border-gray-200 dark:border-gray-800 h-full flex flex-col">
                                    
                                    {/* Картинка */}
                                    <div className="w-full h-48 mb-4 flex items-center justify-center overflow-hidden rounded-xl  dark:bg-gray-900">
                                        <img
                                            className="max-w-full max-h-full object-contain"
                                            src={`/image/catalog/${stack.id}`}
                                            alt={stack.title}
                                        />
                                    </div>

                                    {/* Текст */}
                                    <div>
                                        <h3 className="text-lg mb-2 font-semibold">
                                            {stack.title}
                                        </h3>
                                        <p className="text-muted dark:text-muted-dark text-sm leading-relaxed">
                                            {stack.description}
                                        </p>
                                    </div>
                                </div>
                                </Link>
                          
                        </motion.div>
                    ))}
                </div>
            </Container>
        </div>
    )
}

export default TechStack
